import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { environment } from '../../environments/environment';
import { AuthService } from '../core/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService implements OnDestroy {
  private lastConnectionEmail: {email: string, gsi4pk: string} | null = null ;

  private subject: WebSocketSubject<unknown> | undefined;

  readonly receiveMessage = new Subject<any>();

  constructor(private readonly authService: AuthService) {}

  makeConnection() {
    const detailObj = this.authService.getUserIndexedDb() || {};
    const token = String(detailObj?.fm_user) || this.authService?.accessToken?.value
    this.subject = webSocket({
      url: `${environment.webSocketUrl}/?token=${token}`,
      closeObserver: {
        next: (res) => {
          if (
            this.authService.isAuthenticated() &&
            res?.type === 'close' &&
            res?.reason?.toLowerCase() === 'going away'
          ) {
            this.reconnect();
          }
        }
      }
    });
  }

  reconnect() {
    if (this.lastConnectionEmail && this.authService.isAuthenticated()) {
      this.connect();
      this.setChatEmail(this.lastConnectionEmail.email);
    }
  }

  readonly connect = (() => {
    let sub: Subscription | undefined;
    return () => {
      if (this.authService.isAuthenticated()) {
        sub?.unsubscribe?.();
        sub = this.subject?.subscribe({
          next: (msg) => {
            this.receiveMessage.next(msg);
          },
          error: () => {
            if (this.authService.isAuthenticated()) {
              this.reconnect();
            }
          }
        });
      }
    };
  })();

  setChatEmail(email: string, gsi4pk?: string) {
    if(gsi4pk) {
      this.lastConnectionEmail = {email, gsi4pk};
    }
    this.send({
      action: 'setEmail',
      name: email,
      uuid: this.lastConnectionEmail?.gsi4pk
    });
  }

  public send(msg) {
    if (this.subject?.closed) {
      this.reconnect();
    }
    this.subject?.next(msg);
  }

  public disconnect() {
    this.lastConnectionEmail = null;
    this.subject?.complete();
    this.subject?.unsubscribe();
  }

  ngOnDestroy() {
    this.disconnect();
  }
}